import { Injectable } from '@angular/core';

import { map, type Observable } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import type { TellentFeatureDiscoveryFeatures } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class TellentFeatureDiscoveryHttpClient {
  constructor(protected httpApi: TellentHttpApiService) {}

  public update(
    data: Partial<TellentFeatureDiscoveryFeatures>,
  ): Observable<TellentFeatureDiscoveryFeatures> {
    return this.httpApi
      .patch(`/api/me/feature-discovery`, null, { featureDiscovery: data }, { skipCompany: true })
      .pipe(map(res => res.data));
  }
}
